import { useRef } from "react";
import { randomIdString } from "../utils/randomIdString"

export const useIdRef = ({str, id}: {str?: string, id?: string}) => {
    const _id = id ?? randomIdString();
    const idRef = useRef(str ? str + _id : _id);
    return idRef;
}